import { render } from "./NewGroupForm.vue?vue&type=template&id=afbc6b36&scoped=true"
import script from "./NewGroupForm.vue?vue&type=script&lang=js"
export * from "./NewGroupForm.vue?vue&type=script&lang=js"

import "./NewGroupForm.vue?vue&type=style&index=0&id=afbc6b36&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afbc6b36"]])

export default __exports__